import { Button, Dropdown, DropdownRef, Loader, Menu, Tooltip } from '@recruit-robin/robin-theme/web-components';
import { Globe_02 } from '@recruit-robin/robin-theme/web-icons';
import { useRef } from 'react';

import { useDictionary } from '@/shared/lib/i18n';
import { AILanguage } from '../../lib';
import { useStyles } from './AILanguageSelector.styles';
import { AILanguageSelectorProps, LanguageOption } from './AILanguageSelector.types';

export const AILanguageSelector = ({
  value = AILanguage.Auto,
  onChange,
  isLoading = false,
}: AILanguageSelectorProps) => {
  const classes = useStyles();
  const dropdownRef = useRef<DropdownRef>(null);
  const dictionary = useDictionary();
  const LANGUAGE_OPTIONS: LanguageOption[] = [
    { value: AILanguage.Dutch, label: dictionary.aiLanguageSelector.dutch, shortLabel: 'NL' },
    { value: AILanguage.English, label: dictionary.aiLanguageSelector.english, shortLabel: 'EN' },
    { value: AILanguage.Auto, label: dictionary.aiLanguageSelector.auto, shortLabel: 'Auto' },
  ];

  const selectedOption = LANGUAGE_OPTIONS.find((option) => option.value === value) || LANGUAGE_OPTIONS[2];

  const handleSelect = (option: LanguageOption) => {
    onChange(option.value);
    dropdownRef.current?.close();
  };

  return (
    <div css={classes.root}>
      <Dropdown
        ref={dropdownRef}
        flipMenu={false}
        placement="bottom-end"
        disabled={isLoading}
        renderMenu={
          <Menu.Root css={classes.dropdownMenu}>
            {LANGUAGE_OPTIONS.map((option) => (
              <Menu.Item.Root key={option.value} onClick={() => handleSelect(option)} selected={value === option.value}>
                <Menu.Item.Radio />
                {option.label}
              </Menu.Item.Root>
            ))}
          </Menu.Root>
        }>
        {({ isOpen }) => (
          <Tooltip
            label={isLoading ? dictionary.translatingMessage : dictionary.aiLanguageSelector.tooltip}
            zIndex={3}
            disabled={isOpen}
            offset={{ mainAxis: 8 }}>
            <Button
              startIcon={isLoading ? <Loader size={14} /> : <Globe_02 size={16} />}
              label={isLoading ? '' : selectedOption.shortLabel}
              onClick={() => {}}
              style="text"
              type="highlight"
              disabled={isLoading}
            />
          </Tooltip>
        )}
      </Dropdown>
    </div>
  );
};
